import { Stack, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	label: string;
	value?: string;
	children?: ReactNode;
};

export const ActivityInfoRow: FC<Props> = ({ label, value, children }) => (
	<Stack direction="row" alignItems="flex-start">
		<Typography variant="hint" width={96} flexShrink={0} pt={0.4}>
			{label}
		</Typography>
		<Typography variant="bodyMedium" component="div" flex={1}>
			{children ?? value}
		</Typography>
	</Stack>
);
